import { extractValidEmails } from '#/shared/utils/formHelper';

import { ForwardRequestApiData } from '../types/ForwardRequestApi';
import { ForwardRequestFormValues } from '../types/ForwardRequestFormValues';

/**
 * Maps `ForwardRequestFormValues` data to the `ForwardRequestApiData`.
 * @param {ForwardRequestFormValues} source The form data object
 */
export const mapForwardRequestFormValuesToForwardRequestApiData = (
  source: ForwardRequestFormValues,
): ForwardRequestApiData => {
  const data: ForwardRequestApiData = {
    full_name: source.requesteeName.trim(),
    email: source.requesteeEmail.trim(),
    forwarder_name: source.forwarderName.trim(),
  };

  if (source.forwarderMessage?.trim()) {
    data.message = source.forwarderMessage.trim();
  }

  const validEmails = extractValidEmails(source.forwarderEmails);
  if (validEmails) {
    data.email_copy_to = validEmails;
  }

  return data;
};
